module.exports = __webpack_public_path__ + "img/19_39.c5996514.png";